import styled from "@emotion/styled";

import { BREAKPOINTS, media } from "../constants";
import { Div } from "./layout";

export const ScrollablePetListWrapper = styled(Div)`
  label: scrollable-pet-list-wrapper;
  position: relative;
  overflow-x: auto;
  width: ${(props) => props.width || "100%"};
  height: ${({ addEvent }) => (addEvent ? "100%" : "auto")};
  display: flex;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const AccountPetList = styled.ul`
  label: account-pet-list;
  display: flex;
  flex-direction: row;
  gap: ${({ addEvent }) => (addEvent ? "10px" : "20px")};
  padding-left: 10px;
  height: fit-content;
  width: ${(props) => props.width || "100%"};
  flex-wrap: ${({ addEvent }) => (addEvent ? "wrap" : "nowrap")};
  justify-content: ${({ addEvent }) => (addEvent ? "center" : "flex-start")};
  margin: 0;
  flex-shrink: 0;
`;

export const PetListItem = styled.li`
  label: pet-list-item;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: ${(props) => props.fontSize || "14px"};
  gap: 5px;
  color: ${({ selected, theme }) =>
    selected ? theme.palette.primary.main : theme.palette.text.primary};
  font-weight: ${({ selected }) => (selected ? "600" : "400")};
  background-color: ${({ addEvent, theme, selected }) =>
    addEvent && selected
      ? theme.custom.greenLight
      : addEvent
      ? theme.custom.white
      : ""};
  padding: ${({ addEvent, isDesktop }) =>
    addEvent && !isDesktop ? "10px" : addEvent && isDesktop ? "" : ""};
  border-radius: ${({ addEvent }) => (addEvent ? "20px" : "")};
  width: ${({ addEvent, isDesktop }) =>
    isDesktop && addEvent ? "auto" : addEvent ? "100px" : "auto"};
  height: ${({ addEvent }) => (addEvent ? "auto" : "")};
  border: ${({ theme, selected, addEvent, isDesktop }) =>
    isDesktop && addEvent
      ? "none"
      : selected && addEvent
      ? `2px solid ${theme.palette.primary.main}`
      : addEvent
      ? `1px solid ${theme.custom.grayInputs}`
      : "none"};
`;

export const AddPetCircle = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #eee;
  color: #888;
  cursor: pointer;
  border: ${({ theme }) => `1px solid ${theme.custom.grayInputs}`};
`;

export const AccountPetDetails = styled(Div)`
  label: account-pet-details;
  justify-content: flex-start;
  padding: 20px;
  gap: ${(props) => props.gap || "20px"};
  border-radius: 20px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  height: ${(props) => props.height || "auto"};
  background-color: ${({ theme }) => theme.custom.white};

  h3 {
    font-size: 16px;
    color: ${({ theme }) => theme.custom.grayDark};
    font-weight: 500;
  }

  ${media.min(BREAKPOINTS.tabletMin)} {
    align-items: center;
  }
`;

export const SidebarWrapper = styled.div`
  label: sidebar-wrapper;
  position: fixed;
  top: 0;
  right: 0;
  width: 80%;
  height: 100%;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 2001;
  transition: transform 0.3s ease;

  ${media.min(BREAKPOINTS.tabletMin)} {
    width: 25%;
  }
`;

export const Backdrop = styled.div`
  label: backdrop;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 2000;
`;

export const SidebarList = styled.ul`
  list-style: none;
  
  margin: ${(props) => props.margin || "0"};
  padding: 0;
  width: ${(props) => props.width || '100%'};
  
`;

export const SidebarListBreeds = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-y: auto;
`;

export const SidebarListItem = styled.li`
  width: ${(props) => props.width || '100%'};
  padding: ${(props) => props.padding || '12px 0'};
  font-size: ${(props) => props.fontSize || "16px"};
  font-weight: ${(props) => props.fontWeight || "500"};
  cursor: ${(props) => (props.noPointer ? "default" : "pointer")};
  color: ${({ selected, theme }) =>
    selected ? theme.palette.primary.main : theme.palette.text.primary};
  display: flex;
  gap: ${(props) => props.gap || ""};
  flex-direction: ${(props) => props.direction || "row"};
  justify-content: ${(props) => props.justify || "space-between"};
  align-items: ${(props) => props.align || "center"};
  border-bottom: ${({ current, noBorder, theme }) =>
    current
      ? `1px solid ${theme.custom.gray}`
      : noBorder
      ? "none"
      : `1px solid ${theme.custom.grayLight}`};
  border-top: ${({ borderTop, theme }) =>
    borderTop ? `1px solid ${theme.custom.grayLight}` : "none"};

  &:last-child {
    border-bottom: none;
  }
`;

export const PastEventsList = styled.li`
  label: past-event-item;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 5px;
  border-bottom: 0.5px solid ${({ theme }) => theme.custom.grayBorder};
  padding-bottom: 10px;
  font-size: 14px;
`;

export const UpcomingEventsList = styled.li`
  label: upcoming-event-item;
  display: flex;
  flex-direction: ${(props) => props.direction || "column"};
  justify-content: space-between;
  align-items: center;
  width: 100%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  gap: 8px;
  padding: 10px;
  font-size: 14px;
  background-color: ${({ theme }) => theme.custom.white};
  ${({ alert, theme }) =>
    alert === "expired"
      ? `border-left: 3px solid ${theme.palette.error.main};`
      : alert === "soon"
      ? "border-left: 3px solid #f69634;"
      : ""};

  @media (min-width: 800px) {
    justify-content: flex-start;
    box-shadow: none;
    border-left: none;
    border-radius: 0;
    padding: 20px 0;
    cursor: pointer;
    
  }
`;

export const UpcomingEventsListBorder = styled.div`
  border-bottom: 1px solid rgb(169, 169, 169);
  width: 100%;

  ${media.max(BREAKPOINTS.mobileMax)} {
    border-top: none;
    border-bottom: none;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const FaqList = styled.ul`
  label: faq-list;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
`;

export const FaqItem = styled.li`
  label: faq-item;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.custom.grayLight};
  
  &:last-child {
    border-bottom: none;
  }
`;

export const FaqQuestion = styled.div`
  label: faq-question;
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.primary};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  
  // &:hover {
  //   background-color: ${({ theme }) => theme.custom.grayLight || '#f5f5f5'};
  // }
`;

export const FaqAnswer = styled.div`
  label: faq-answer;
  padding: 0 20px;
  max-height: ${({ isOpen }) => (isOpen ? '1000px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.text.primary};
  line-height: 1.5;
  white-space: pre-line;
  
  ${({ isOpen }) => isOpen && `
    padding: 0 20px 16px 20px;
  `}
`;

export const FaqIcon = styled.span`
  label: faq-icon;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;  
  transform: ${({ isOpen }) => (isOpen ? 'rotate(270deg)' : 'rotate(90deg)')};
  font-size: 10px;
  color: ${({ theme }) => theme.palette.text.secondary || '#666'};
  margin-left: 8px;
  flex-shrink: 0;
`;


